/* Amélioration progressive : la rangée reste défilable sans JavaScript. */
(() => {
  if (customElements.get('sd-brand-rail')) return;
  class SdBrandRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-brand-track]');
      this.controls = this.querySelector('[data-brand-controls]');
      this.previous = this.querySelector('[data-brand-previous]');
      this.next = this.querySelector('[data-brand-next]');
      if (!this.track || !this.controls || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.controls.hidden = false;
      const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const move = direction => this.track.scrollBy({ left: direction * Math.max(this.step(), this.track.clientWidth * 0.75), behavior: behavior() });
      this.previous.addEventListener('click', () => move(-1), { signal });
      this.next.addEventListener('click', () => move(1), { signal });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { signal, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const positions = { ArrowLeft: this.track.scrollLeft - this.step(), ArrowRight: this.track.scrollLeft + this.step(), Home: 0, End: maximum };
        if (!(event.key in positions)) return;
        event.preventDefault();
        this.track.scrollTo({ left: positions[event.key], behavior: behavior() });
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const item = event.target.closest('.sd-brand-gallery__item');
        if (item) item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
      }, { signal });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    step() {
      const item = this.track.querySelector('.sd-brand-gallery__item');
      return (item ? item.getBoundingClientRect().width : 180) + (parseFloat(getComputedStyle(this.track).gap) || 0);
    }
    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
      this.controls.hidden = maximum <= 2;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('sd-brand-rail', SdBrandRail);
})();
